export enum ELibraryView {
  LIBRARY_ITEMS = 'library_items',
  DETAILS = 'details',
}
